export default function totalOffsetTop(el) {
  if (el.offsetParent === document.body) return el.offsetTop;

  return el.offsetTop + totalOffsetTop(el.offsetParent);
}
